$(function ($) {
  var $trainingApp = $(".positronic-app.training");
  var curModule = 0;

  var moduleChangeTO;
  var moduleStable = true; // track when user has been in the same module without changing
  $trainingApp.on(TRAINING_EVENTS.NEW_MODULE, function (e, moduleInfo) {
    // end and log last section
    if (moduleStable) logHeartbeat();

    clearTimeout(moduleChangeTO);
    moduleStable = false;
    moduleChangeTO = setTimeout(function () {
      moduleStable = true;
    }, 2000);

    // set curModule for next heartbeat
    curModule = moduleInfo.index;
  });

  var lastLog = Date.now();
  function logHeartbeat() {
    if (!moduleStable) {
      logTO = setTimeout(logHeartbeat, 5000);
      return;
    }

    clearTimeout(logTO);

    var duration = Date.now() - lastLog;
    lastLog = Date.now();
    $.post(
      window.SITE_SETTINGS.ajaxurl,
      {
        action: "posi_update_student_analytics",
        time: duration / 1000,
        lesson_id: window.posiLessonId,
        module_id: curModule,
      },
      function (res) {
        logTO = setTimeout(logHeartbeat, 5000);
      }
    );
  }

  var logTO = setTimeout(logHeartbeat, 5000);
});
